<script>
    export let state;
</script>

<div class="pageloader is-success {state === true ? 'is-active': ''}">
    <span class="title">Pobieramy dane pracowników...</span>
</div>